module.exports = __webpack_public_path__ + "static/top-7910073b042166217a6b725210c4f430.png";